import React from 'react';

const HandPage = React.lazy(() =>
  import('../Pages/HandPage/HandPage')
);
const url = '/merryhand';
export const routes = [
  { path: '/', name: 'Privacy And Policy', element: HandPage },
]